<template>
    <div v-if="subdomains.length">
        <q-select v-model="subdomain"
	          :options="subdomains"
	          class="q-mb-md"
	          label="Select your Custom Domain"
	          style="background:rgb(251 233 231);"
	          name="subdomain"
	          dropdown-icon="fa-solid fa-circle-chevron-down"
	          @update:model-value="value => $emit('update:subdomain', value)"
	          col
              transition-show="scale"
              transition-hide="scale"
              :disable="useUnSubdomain"
	          outlined>
            <template v-slot:selected>
                <div v-if="subdomain" class="text-center full-width text-h5">
                    <span class="text-deep-orange">{{ subdomain.label.toUpperCase() }}</span>
                    <span class="text-blue">.{{ appDomain }}</span>
                </div>
            </template>
        </q-select>
    </div>
	<div v-else class="rounded-borders notice text-primary text-subtitle1 bg-deep-orange-1 text-center full-width q-mb-md" style="word-wrap: break-word;">
        <div v-if="store.getters.isAuthenticated">
            <router-link :to="{name:'subdomains.list'}" class="route-link">
                Click here to register your Custom Domain for FREE:
                <span class="text-blue">https://</span>
                <span class="text-deep-orange">Your-Name</span>
                <span class="text-blue">.{{ appDomain }}/</span>
                <span class="text-deep-orange">Your-Tags</span>
            </router-link>
            <p>(expiration: {{ subdomainExpiration }} days, free renewable)</p>
            Or use Memo Links without Domain
            <span class="text-blue">https://</span>
            <span class="text-blue">{{ appDomain }}/</span>
            <span class="text-deep-orange">Keyword1-Keyword2-Keyword3...</span>
            <p>(expiration: {{ mlExpiration }} days)</p>
        </div>
        <div v-else>
            <a href="javascript:void(0);" class="route-link" @click.prevent="openDialog">
                Click here to sign-up and register your Custom Domain for FREE:
                <span class="text-blue">https://</span>
                <span class="text-deep-orange">Your-Name</span>
                <span class="text-blue">.{{ appDomain }}/</span>
                <span class="text-deep-orange">Your-Tags</span>
            </a>
        </div>
	</div>
</template>

<script setup>
import { computed, inject, onMounted, ref } from 'vue'
import { useSubDomainService } from '../../services/subDomainService'
import { useStore } from 'vuex'
import LoginDialog from './dialogs/LoginDialog.vue'
import { useQuasar } from 'quasar'

const props = defineProps(['subdomain']);
const store = useStore();
const quasar = useQuasar();

const emits = defineEmits(['update:subdomain']);

const subDomainService = useSubDomainService();
const appDomain = inject('appDomain');

const subdomain = ref(props.subdomain);
const subdomains = ref([]);
const useUnSubdomain = ref(false)

const limits = computed(() => store.getters.getLimits)
const subdomainExpiration = computed(() => parseInt(limits?.value?.getSubdomainExpiration()?.value))
const mlExpiration = computed(() => parseInt(limits?.value?.getMlExpiration()?.value))

onMounted(async () => {
    if (store.getters.isAuthenticated) {
        subdomains.value = await subDomainService
            .getAll()
            .then(list => list.map(item => {
                    return {
                        value: item.id,
                        label: item.name.toUpperCase()
                    }
                })
            );
        if (subdomains.value.length) {
            subdomain.value = subdomains.value[0];
        }
    }

    emits('update:subdomain', subdomain.value)
});

function openDialog() {
    quasar.dialog({
        component: LoginDialog,
    });
}
</script>

<style scoped>
:deep(i.q-icon) {
	color: #ff5722;
}

div.notice {
	border: 1px solid #919090;
	padding: 10px 0;
}
</style>
